import { c as _c } from "react/compiler-runtime";
import { AllTreatmentCarouselCard } from "@/widgets/treatment-case/ui/molecules";
import { TreatmentCaseSummaryResponse } from "@/shared/types/type/treatment";
interface AllTreatmentCarouselProps {
  summaryList: TreatmentCaseSummaryResponse[];
}
const AllTreatmentCarousel = t0 => {
  const $ = _c(4);
  const {
    summaryList
  } = t0;
  let t1;
  if ($[0] !== summaryList) {
    t1 = summaryList.map(_temp);
    $[0] = summaryList;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex gap-2.5 overflow-x-auto px-4 py-2 scrollbar-hide">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default AllTreatmentCarousel;
function _temp(summary, index) {
  return <AllTreatmentCarouselCard key={`all-treatment-carousel-card-${index}`} summary={summary} index={index} />;
}